(function(){
  'use strict';
  function init(scope){
    const data=scope.querySelector('[data-hu-reviewed-gallery]');
    if(data&&!data.dataset.initialized){
      data.dataset.initialized='true';
      const report=JSON.parse(data.textContent),lang=report.language;
      if(report.requiresSize&&!new URLSearchParams(location.search).has('variant')){
        scope.querySelectorAll('[data-hu-size]').forEach(button=>button.setAttribute('aria-pressed','false'));
        const feedback=scope.querySelector('.ring-choice .microcopy[aria-live]');
        if(feedback)feedback.textContent=lang==='zh'?'尚未選擇戒圍':'No size selected';
        const buy=scope.querySelector('button[name="add"]');
        if(buy){buy.disabled=true;buy.textContent=lang==='zh'?'請先選擇戒圍':'CHOOSE YOUR SIZE FIRST';}
      }
      scope.querySelectorAll('[data-media]').forEach(button=>button.addEventListener('click',()=>{
        const media=report.gallery.find(item=>item.id===button.dataset.media);
        if(!media)return;
        const frame=scope.querySelector('#variant-photo'),image=frame.querySelector('img');
        const demonstration=media.id==='lifestyle';
        const edition=demonstration?media.demonstrationName?.[lang]||report.editionLabel:report.editionLabel;
        image.src=media.image;
        image.alt=report.name+' · '+edition+' · '+media.label[lang];
        image.width=media.width;image.height=media.height;
        frame.dataset.mediaKind=media.id;
        frame.dataset.mediaEdition=demonstration?media.demonstrationVariant:report.edition;
        scope.querySelectorAll('[data-media]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
        const caption=scope.querySelector('.media-caption');
        caption.replaceChildren();
        if(media.caption?.[lang]){
          const strong=document.createElement('strong');strong.className='shown-edition';strong.textContent=edition;
          caption.append(strong,document.createTextNode(media.caption[lang]));return;
        }
        const strong=document.createElement('strong');strong.className='shown-edition';
        strong.textContent=edition+' · '+(demonstration?(lang==='zh'?'使用示範款':'DEMONSTRATION EDITION'):(lang==='zh'?'你的款式':'YOUR EDITION'));
        caption.append(strong,document.createTextNode(demonstration?(lang==='zh'?'AI 使用情境示意，搭配道具不包含在商品中。':'AI scene illustration. Contextual props are not included.'):(lang==='zh'?'依此款式商品參考圖製作的 AI 示意圖。':'AI product illustration based on this edition’s reference.')));
      }));
    }
    scope.querySelectorAll('[data-filter]').forEach(button=>{
      if(button.dataset.initialized)return;button.dataset.initialized='true';
      button.addEventListener('click',()=>{
        const key=button.dataset.filter;
        scope.querySelectorAll('.filter-row [data-filter]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
        scope.querySelectorAll('.shop-main [data-product-card]').forEach(item=>item.hidden=key!=='all'&&item.dataset.type!==key);
      });
    });
    const requested=new URLSearchParams(location.search).get('ritual');
    const category=[...scope.querySelectorAll('[data-filter]')].find(item=>item.dataset.filter===requested);
    if(category)category.click();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
